import { TextField } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import { withStyles } from '@material-ui/core/styles';
import CachedIcon from '@material-ui/icons/Cached';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from './style/gstheme';
import Datatype from './Datatype';
import { DATATYPES } from './utils/constants';

const styles = Object.assign({}, globalStyles);

class BooleanField extends React.Component {

    handleChange = (checked) => this.props.onUpdate((!checked).toString());

    handleDelete = (checked) => this.props.onDelete(checked.toString());

    render() {

        const { isReadOnly, checked, invalidDatatype, classes, displayDatatype } = this.props;

        return (
            <div>
                <TextField data-test="boolean-value" value={checked ? 'TRUE' : 'FALSE'}
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    style={{ marginTop: '0px' }}
                    helperText={invalidDatatype ? <span data-test="helper-text">This value is no longer valid for the property's datatype</span> : ""}
                    InputProps={{
                        className: classes.inputLabel,
                        startAdornment: displayDatatype ? <Datatype dataTest="boolean-datatype" datatype={DATATYPES.BOOLEAN} invalid={invalidDatatype} /> : null,
                        endAdornment: !isReadOnly &&
                            <div>
                                <InputAdornment position="end">
                                    {!invalidDatatype &&
                                        <IconButton data-test="switch-value" size="small" onClick={() => this.handleChange(checked)}>
                                            <CachedIcon fontSize="small" />
                                        </IconButton>
                                    }
                                    <IconButton data-test="delete-value" size="small" onClick={() => this.handleDelete(checked)}>
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </InputAdornment>
                            </div>,
                        inputProps: {
                            "data-test": "boolean-text",
                            readOnly: true
                        }
                    }
                    }
                />
            </div>
        );
    }
}

BooleanField.defaultProps = {
    isReadOnly: false,
    invalidDatatype: false,
    displayDatatype: true
};

BooleanField.propTypes = {
    invalidDatatype: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    onDelete: PropTypes.func,
    displayDatatype: PropTypes.bool,
    onUpdate: PropTypes.func,
    checked: PropTypes.bool.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(BooleanField);